module.exports = __webpack_public_path__ + "media/img/illustrations/icons/applications-date-e9e1e33f144ec788ad0c1640fde17af0.svg";